<template>
    <select v-model="selected"
            id="language-select"
            @change="changeJurisdictionAction">
        <option v-for="(item, index) in languagessa"
                :value="item.code"
                :key="item.code">
            {{ item.name }}
        </option>
    </select>
</template>
<script>

    import { storeToRefs } from 'pinia';
    import { useLegalStore } from '../../stores/legal';
    const site = window.__pt.settings.site;
    const userLocation = window.__pt.userLocation;

    export default {

        data() {
            return {
                selected: userLocation.country.toLowerCase() === "us" ? "BTC" : "Price Res, SAPI de CV",
                languagessa: [
                    {
                        name: this.__("information.us"),
                        code: 'BTC',
                    },
                    {
                        name: this.__("information.mx"),
                        code: 'Price Res, SAPI de CV'
                    },
                    {
                        name: this.__("information.co"),
                        code: 'TiquetesBaratos - PRICE RES S.A.S'
                    }
                ]
            }
        },
        setup() {
            const useLegal = useLegalStore();
            const { changeJurisdiction, setJuridictionSelected } = useLegal;
            const { getLanguageSelected } = storeToRefs(useLegal);

            return { getLanguageSelected, changeJurisdiction, setJuridictionSelected }
        },
        methods: {
            changeJurisdictionAction() {
                this.setJuridictionSelected(this.selected);
                this.changeJurisdiction();
            }
        }
    }
</script>
<style scoped lang="scss">
    #language-select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        position: relative;
        min-width: 200px;
        width: 300px;
        padding: 16px;
        background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22%3E%3Cpath d%3D%22M11.1174 16.6328C11.6057 17.1211 12.3987 17.1211 12.8869 16.6328L17.8869 11.6328C18.2463 11.2734 18.3518 10.7383 18.1565 10.2695C17.9612 9.80078 17.508 9.49609 17.0002 9.49609L7.00022 9.5C6.49632 9.5 6.03928 9.80469 5.84397 10.2734C5.64866 10.7422 5.75803 11.2773 6.1135 11.6367L11.1135 16.6367L11.1174 16.6328Z%22 fill%3D%22%23696770%22%2F%3E%3C%2Fsvg%3E');
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 24px;
        background-color: var(--bg-base);
        border: 1px solid var(--border-strong);
        border-radius: 4px;
        color: var(--text-strong);
        cursor: pointer;
    }
</style>
